export class Cloud {
    constructor(indicator, index, gradientMode, color1, color2) {
        this.indicator = indicator;
        this.cloudIndex = index;
        this.gradientMode = gradientMode;
        this.iColor1 = color1;
        this.iColor2 = color2;
    }
    set(value1, value2, /* ColorSwitch colorSwitch = ColorSwitch.Allow, */ offset = 0) {
        // ColorSwitch - должен позволять перерисовать цвет заливки облака на пересечениях  - пока не реализовано
        this.indicator.SetCloud(this.cloudIndex, offset, value1, value2, this.iColor1, this.iColor2, this.gradientMode, this._timeShift);
    }
    get colorAscending() {
        return this.iColor1;
    }
    set colorAscending(value) {
        this.iColor1 = value;
        this.indicator.setCloudColors(this.cloudIndex, this.iColor1, this.iColor2);
    }
    get colorDescending() {
        return this.iColor2;
    }
    set colorDescending(value) {
        this.iColor2 = value;
        this.indicator.setCloudColors(this.cloudIndex, this.iColor1, this.iColor2);
    }
    get gradientMode() {
        return this._gradientMode;
    }
    set gradientMode(value) {
        this._gradientMode = value;
        this.indicator.setCloudGradient(this.cloudIndex, this._gradientMode);
    }
    get timeShift() {
        return this._timeShift;
    }
    set timeShift(value) {
        this._timeShift = value;
        this.indicator.setCloudTimeShift(this.cloudIndex, this._timeShift);
    }
    get valueShift() {
        return this._valueShift;
    }
    set valueShift(value) {
        this._valueShift = value;
        this.indicator.setCloudValueShift(this.cloudIndex, this._valueShift);
    }
}
